<template>
  <div class="lesson-c">
    <div class="mb-4">
      <p class="mb-0 font-weight-bolder">Lesson</p>
      <template v-if="Object.keys(lesson).length">
        <div class="d-flex justify-content-between align-items-center lesson-info">
          <p class="mb-0">{{ lesson.name }}</p>
          <a
            target="_blank"
            :href="lesson.file"
            download="download"
            class="lesson-btn btn btn-violet rounded-pill"
          >
            <span class="material-icons mr-1">download</span><label class="mb-0">PDF</label>
          </a>
        </div>
      </template>
    </div>
    <div
      ref="containerHtml"
      v-html="$sanitize(lesson.description)"
      class="wrapper-content mb-3"
    ></div>
    <div class="helper--card p-3 m-auto">
      <p class="helper--card__text">Was this lesson helpful?</p>
      <div class="helper--card--actions">
        <button
          type="button"
          v-for="buttonhelpFul in buttonsHelpFul"
          @click.stop="helpFullController({ isHelpful: buttonhelpFul.isHelpful })"
          :class="
            lessonDetail.helpful === buttonhelpFul.helpfulText
              ? 'btn btn-violet rounded-pill mr-2'
              : 'btn btn-violet_outlined rounded-pill mr-2'
          "
        >
          {{ buttonhelpFul.labelText }}
        </button>
      </div>
    </div>
    <div v-if="!lessonDetail.viewed" class="mt-4">
      <button
        type="button"
        :disabled="lessonDetail.viewed"
        @click.stop="completeController()"
        class="atm-button bg-main btn-complete rounded-pill mx-auto d-block"
      >
        Mark complete
      </button>
    </div>
  </div>
</template>

<script>
import { useLearnSkillsStore, useSessionStore } from '@/common/plugins/store';
import {
  getLessonDetail,
  markVideoisViewed,
  markLessonAsComplete,
  setInfoIsHelpfull,
} from '../services';

export default {
  data() {
    const learnStore = useLearnSkillsStore();
    const sessionStore = useSessionStore();
    const buttonsHelpFul = [
      {
        labelText: 'No',
        isHelpful: false,
        helpfulText: 'unhelpful',
      },
      {
        labelText: 'Yes',
        isHelpful: true,
        helpfulText: 'helpful',
      },
    ];
    return {
      timeToMarkTheVideoAsViewed: 90,
      timerVideo: null,
      time: 0,
      store: { ...learnStore, ...sessionStore },
      lessonDetail: {
        viewed: true,
        date: '',
        helpful: null,
        watched_video: false,
        watched_video_date: '',
      },
      buttonsHelpFul,
    };
  },
  async mounted() {
    try {
      const lessonExtraInfo = await getLessonDetail(this.lessonId);
      this.lessonDetail = { ...lessonExtraInfo };
      if (this.allowTimer) {
        this.initTimerToVideo();
      }
    } catch (error) {
      console.error(error);
    }
  },
  destroyed() {
    this.timerVideo && this.destroyTimer();
  },
  computed: {
    userIsAParent() {
      return this.store.profileType == 'parent';
    },
    lessonId() {
      return this.$route.params.lesson;
    },
    lesson() {
      return this.store.getLessonById(this.lessonId) || {};
    },
    allowTimer() {
      const hasVideo = this.lesson.video;
      const hasWatchedvideo = this.lessonDetail.watched_video;
      return !this.userIsAParent && hasVideo && !hasWatchedvideo;
    },
  },
  methods: {
    async helpFullController({ isHelpful = false }) {
      const lesson = this.lessonId;
      try {
        const lessonUpdate = await setInfoIsHelpfull({ helpful: isHelpful, lessonId: lesson });
        this.lessonDetail = { ...lessonUpdate };
      } catch (error) {
        console.error('[Help Full]', error);
      }
    },
    async completeController() {
      try {
        await markLessonAsComplete(this.lessonId);
        this.$router.push({
          name: 'LearnSkills',
          params: {
            markComplete: true,
          },
        });
      } catch (error) {
        console.error('[Complete controller]', error);
      }
    },
    initTimerToVideo() {
      this.timerVideo = setInterval(() => (this.time += 1000), 1000);
    },
    destroyTimer() {
      clearInterval(this.timerVideo);
    },
  },
  watch: {
    async time(newTime, oldTime) {
      const seconds = newTime / 1000 || 0;
      if (seconds === this.timeToMarkTheVideoAsViewed) {
        this.destroyTimer();
        try {
          await markVideoisViewed(this.lessonId);
        } catch (error) {
          console.error('Error trying to send video information', error);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.lesson-c {
  .btn {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    font-size: 13px;
    &-violet {
      background: var(--color-main);
      color: white !important;
      &_outlined {
        border: 1px solid var(--color-main);
        color: var(--color-main);
      }
    }

    &-complete {
      width: 370px;

      @media only screen and (max-width: 600px) {
        width: 100%;
      }
    }
  }
}
.wrapper-content {
  iframe {
    width: 100%;
    border-radius: 12px;
    border: solid 0 transparent;
  }
  img {
    width: 100%;
    object-fit: contain;
  }
}
.lesson-info {
  .material-icons {
    font-size: 17px;
  }
  .lesson-btn {
    display: flex;
    align-items: center;
  }
}
.helper--card {
  background: #ffffff;
  box-shadow: var(--atm-shadow);
  border-radius: 12px;
  max-width: 320px;
  text-align: center;

  &__text {
    color: var(--color-main);
    font-weight: bold;
  }
}
</style>
